<template>
  <div
    class="btn spacer-little btn-calculator"
    v-on:click="$emit('click')">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['label']
}
</script>